import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
	list: [],
	currency: null,
	error: "",
	loading: false,
};

// ADD_state
export const addCurrency = createAsyncThunk(
	"state/addCurrency",
	async (values) => {
		try {
			const { data } = await axios({
				method: "post",
				url: `currency/`,
				data: {
					...values,
				},
			});
			toast.success("Currency added successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in adding Currency try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

// DELETE_currency
export const deleteCurrency = createAsyncThunk(
	"currency/deleteCurrency ",
	async (id) => {
		try {
			const resp = await axios({
				method: "delete",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `currency/${id}`,
			});

			toast.success("Currency deleted successfully!");
			return {
				data: resp.data.id,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in deleting Currency try again");
			console.log(error.message);
		}
	}
);

// currencyS
export const getAllCurrency = createAsyncThunk(
	"currency/getAllCurrency",
	async () => {
		try {
			const { data } = await axios.get(`currency/`);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

export const updateCurrency = createAsyncThunk(
	"currency/updateCurrency",
	async ({ id, values }) => {
		try {
			const { data } = await axios({
				method: "put",

				url: `currency/${id}`,
				data: {
					...values,
				},
			});
			toast.success("Currency updated successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in updating Currency try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

const currencySlice = createSlice({
	name: "currency",
	initialState,
	reducers: {
		clearCurrency: (state) => {
			state.currency = null;
		},
	},
	extraReducers: (builder) => {
		// 1) ====== builders for getAllCurrency ======

		builder.addCase(getAllCurrency.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(getAllCurrency.fulfilled, (state, action) => {
			state.loading = false;
			state.list = action.payload;
		});

		builder.addCase(getAllCurrency.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 2) ====== builders for addCurrency  ======

		builder.addCase(addCurrency.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(addCurrency.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(addCurrency.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 3) ====== builders for state ======

		builder.addCase(updateCurrency.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(updateCurrency.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(updateCurrency.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 4) ====== builders for deleteCurrency  ======

		builder.addCase(deleteCurrency.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(deleteCurrency.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(deleteCurrency.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});
	},
});

export default currencySlice.reducer;
export const { clearCurrency } = currencySlice.actions;
